import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './additionalHonorariumForm';
import List from './additionalHonorariumList';

const settings = {
    pathRegister: paths.additionalHonorariumRegister,
    pathList: paths.additionalHonorarium,
    apiPath: 'additional-honorarium',
    permissionAdmin: null,
    title: 'Honorários',
    entity: 'additionalHonorarium',
};

const AdditionalHonorarium: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const AdditionalHonorariumList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { AdditionalHonorarium, AdditionalHonorariumList };
